module.exports = __webpack_public_path__ + "img/img01.03273210.jpg";